module.exports = __webpack_public_path__ + "static/media/bagy2.6d0cf78c.png";